/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 ~ Copyright 2020 Adobe Systems Incorporated
 ~
 ~ Licensed under the Apache License, Version 2.0 (the "License");
 ~ you may not use this file except in compliance with the License.
 ~ You may obtain a copy of the License at
 ~
 ~     http://www.apache.org/licenses/LICENSE-2.0
 ~
 ~ Unless required by applicable law or agreed to in writing, software
 ~ distributed under the License is distributed on an "AS IS" BASIS,
 ~ WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 ~ See the License for the specific language governing permissions and
 ~ limitations under the License.
 ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */

// Use polyfills for modern language features
// The imports and dependencies can be removed if only modern browsers should be
// supported
import 'react-app-polyfill/stable';
import 'react-app-polyfill/ie9';
import 'custom-event-polyfill';

import { Constants, ModelManager, PathUtils } from '@adobe/aem-spa-page-model-manager';
import { createBrowserHistory } from 'history';
import React from 'react';
import { hydrate } from 'react-dom';
import { Router } from 'react-router-dom';
import App from './App';
import './components/import-components';
import { hasTermsComponent } from './utils/pageModelUtils';
import './styles/output.css';

const errorPageRoot = PathUtils.getMetaPropertyValue('cq:errorpages') + '/';
const pageModel = PathUtils.getMetaPropertyValue('cq:pageModel');

document.addEventListener('DOMContentLoaded', () => {
    ModelManager.initialize({ errorPageRoot, model: JSON.parse(pageModel) }).then(pageModel => {
        const history = createBrowserHistory();
        const spaRoot = document.getElementById('spa-root');
        const loader = document.getElementById('Loader__wrapper');
        const includeAcquisitionProvider =
            pageModel[Constants.TYPE_PROP] === 'cob-corp-acquisition/components/xfpage' ||
            pageModel[Constants.TYPE_PROP] === 'cob-corp-acquisition/components/creditonebank/page-templates/acquisition' ||
            pageModel[Constants.PATH_PROP].includes('application-status');

        setTimeout(() => {
            hydrate(
                <Router history={history}>
                    <App
                        includeAcquisitionProvider={includeAcquisitionProvider}
                        history={history}
                        cqChildren={pageModel[Constants.CHILDREN_PROP]}
                        cqItems={pageModel[Constants.ITEMS_PROP]}
                        cqItemsOrder={pageModel[Constants.ITEMS_ORDER_PROP]}
                        cqPath={pageModel[Constants.PATH_PROP]}
                        locationPathname={window.location.pathname}
                    />
                </Router>,
                spaRoot,
            );
            spaRoot.classList.add('hydrated');
            const urlIncludes =[
                'pq-one/data-entry',
                'full-application/data-entry',
                'pre-qualification/application',
                'pre-qualification-result/counter-single-offer',
                ].some((path) => window.location.href.includes(path));

            const hasTerms = urlIncludes ? hasTermsComponent(pageModel) : false;
            if (!urlIncludes || !hasTerms) {
                spaRoot.removeAttribute('style');
                if (loader) {
                    loader.classList.add('no-display');
                }
            }
        }, window.isSafari ? window.safariDeop : 0);
    });
});
